import { useEffect, useRef, useState } from 'react';

export default function SignaturePad({ onChange, testid = 'signature-pad' }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext('2d');
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#0D1B5E';
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    drawing.current = true;
    ref.current.setPointerCapture(e.pointerId);
    const ctx = ref.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext('2d');
    ctx.lineTo(...pos(e));
    ctx.stroke();
    if (empty) setEmpty(false);
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange?.(empty ? null : ref.current.toDataURL('image/png'));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange?.(null);
  };

  return (
    <div className="relative">
      <canvas ref={ref} data-testid={testid}
        onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
        className="w-full h-32 rounded-xl border-2 border-dashed border-ink/25 bg-[#FAFAF7] touch-none cursor-crosshair"/>
      {empty && <span className="pointer-events-none absolute inset-0 grid place-items-center text-xs text-ink/40">Sign here with your finger</span>}
      <button type="button" data-testid={`${testid}-clear`} onClick={clear}
        className="absolute top-2 right-2 text-[10px] font-black uppercase tracking-wider text-ink/50 hover:text-ink">Clear</button>
    </div>
  );
}
